import { intersection } from 'lodash';
import { UserRole } from '../types/enums';

export function hasRoles(userRoles: string[], roles: UserRole[]) {
  const containedRoles = intersection(userRoles, roles);
  return containedRoles.length > 0 && containedRoles[0] != null && containedRoles[0].trim() != '';
}
